import { render } from "./ProjectSourcesContent.vue?vue&type=template&id=550a96d0"
import script from "./ProjectSourcesContent.vue?vue&type=script&lang=js"
export * from "./ProjectSourcesContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__